import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownConfig } from '../../../../@core/data/dropdown-config';
@Component({
  selector: 'ngx-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectInputComponent),
      multi: true,
    },
  ],
})
export class SelectInputComponent implements OnInit, ControlValueAccessor, AfterViewInit {
  @Input() _inputValue = undefined;

  @ViewChild('child', { static: false }) feild: ElementRef;
  @Output() inputValid = new EventEmitter<boolean>();
  @Output() changed = new EventEmitter<string>();
  @Input() bindAttribute: string = null;
  @Input() multiple: boolean = false;
  @Input() options: Array<any> = ['no-options-avilable'];
  @Input() disabled: boolean = false;
  @Input() returnAttr: string = 'id';
  @Input() config: DropdownConfig = {
    // you can find description for each option in this model file
    displayKey: 'name',
    search: true,
    height: 'auto',
    placeholder: 'إختر',
    customComparator: () => {},
    limitTo: 10,
    moreText: 'more',
    noResultsFound: 'غير موجود',
    searchPlaceholder: 'بحث',
    searchOnKey: 'name',
    clearOnSelection: false,
  };
  options2: any[] = [];
  constructor() {}
  get inputValue() {
    return this._inputValue;
  }

  set inputValue(val) {
    this._inputValue = val;
    this.propagateChange(this._inputValue);
  }
  propagateChange = (_: any) => {};

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() {}
  writeValue(value: any) {
    if (value !== undefined) {
      this.inputValue = value;
    }
  }
  selectionChanged(event: any) {
    // console.log(event);
    this.inputValid.emit(true);
    if (this.bindAttribute) {
      this.changed.emit(this.inputValue[this.bindAttribute]);
    } else this.changed.emit(this.inputValue);
  }

  ngOnInit() {
    console.log(this.options);

    this.options.forEach((a) => {
      this.options2.push({ id: a.id, description: a.name });
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.inputValid.emit(false);
    });
  }
}
